
// Module
import routes from './routes';

export default angular.module( 'app.login.module',
    [] )
    .config(routes)
    .name



/** WEBPACK FOOTER **
 ** ./src/guest/login/index.js
 **/